import Button from "@mui/material/Button";
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';

const SetupGuide = ({ url }) => {
  return (
    <Button  className="custom-color-button"
              variant="contained"
              href={url}
              color="info"
              target='_blank'
              sx={{
                fontSize: "15px",
                fontWeight: "300 !important"
              }}>
              <AutoStoriesOutlinedIcon className="autoStoriesOutlinedIcon" color="white"/>
              &nbsp;&nbsp;
              Setup Guide
    </Button>
  );
};

export default SetupGuide;
